// Wem gehört ein Kundenakten-Ordner schon? Rein und ohne React, damit die
// Regel direkt testbar ist (vorher in AkteZuweisenDialog.tsx).

import { Folder, contactName } from "./types";

/**
 * Die bisherigen Kontakte eines zugewiesenen Ordners außer dem, der gerade
 * zuweist — `null`, wenn niemandem oder nur ihm. Eine nur vom Namensabgleich
 * geratene Zuordnung (`exact`/`ambiguous`) ist keine Zuweisung.
 */
export const bisherigerInhaber = (folder: Folder, contactId: number): string | null => {
  if (folder.matchStatus !== "manual") return null;
  const alle = [
    ...(folder.contact?.id ? [{ id: folder.contact.id, name: contactName(folder.contact) }] : []),
    ...(folder.weitereKontakte ?? []).map((w) => ({ id: w.contactId, name: w.name || `Kontakt ${w.contactId}` })),
  ];
  const andere = alle.filter((k) => k.id !== contactId).map((k) => k.name);
  return andere.length ? andere.join(", ") : null;
};
